import { render, staticRenderFns } from "./patrolTask.vue?vue&type=template&id=56021c63&scoped=true&"
import script from "./patrolTask.vue?vue&type=script&lang=ts&"
export * from "./patrolTask.vue?vue&type=script&lang=ts&"
import style0 from "./patrolTask.vue?vue&type=style&index=0&id=56021c63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56021c63",
  null
  
)

export default component.exports